import { getImagePath } from '@/utils/images';
import WebinarHtml from './WebinarHtml';
import { Container } from './WebinarShared';

const WebinarReferenceStats = ({ stats }) => {
  if (!stats?.length) return null;

  return (
    <section className="bg-grey-950 py-16 md:py-[88px]">
      <Container>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {stats.map((stat) => (
            <div
              key={stat.id}
              className="flex flex-col items-start justify-center rounded-2xl border border-[#404040] p-7"
            >
              {stat.logo?.url && (
                <a
                  href={stat.logoUrl || undefined}
                  target={stat.logoUrl ? '_blank' : undefined}
                  rel="noopener noreferrer"
                >
                  <img
                    src={getImagePath(stat.logo)}
                    alt={stat.logo.alternativeText || ''}
                    className="mb-6 w-[120px]"
                  />
                </a>
              )}
              <WebinarHtml
                html={stat.text}
                className="font-poly text-[32px] leading-[1.2] font-light text-white [&_strong]:font-light [&_strong]:text-brand-400"
              />
              {stat.ctaLabel && (
                <a
                  href={stat.ctaUrl || '#'}
                  target={stat.ctaUrl ? '_blank' : undefined}
                  rel="noopener noreferrer"
                  className="mt-8 inline-flex items-center justify-center rounded-full border border-white/35 px-[27px] py-3.5 text-base text-white transition-colors hover:border-brand-400 hover:text-brand-400"
                >
                  {stat.ctaLabel}
                </a>
              )}
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default WebinarReferenceStats;
